export const UTENTE_PRIVATO = 'Privato'
export const UTENTE_AZIENDA = 'Business/P.Iva'
export const TIPO_UTENTE = [UTENTE_PRIVATO, UTENTE_AZIENDA]

export const TIPOLOGIA_VEICOLO = [
  'City Car',
  'Berlina',
  'Station wagon',
  'Monovolume',
  'Crossover',
  'Suv',
  'Vettura full electric',
  'Veicolo commerciale',
]

export const BUDGET_MENSILE_PREVISTO_IVA_INCLUSA = [
  'fino a 300€',
  'da 300€ a 500€',
  'da 500€ a 700€',
  'da 700€ a 1.000€',
  'oltre 1.000€',
]

export const BUDGET_MENSILE_PREVISTO_IVA_ESCLUSA = [
  'fino a 250€',
  'da 250€ a 400€',
  'da 400€ a 600€',
  'da 600€ a 800€',
  'oltre 800€',
]

export const KM_PERCORSI = ['10.000', '15.000', '20.000', '25.000', '30.000', '40.000', '50.000']

export const FLOTTA_POTENZIALE_UTENTE_PRIVATO = [1, 2, 3, 4]
